<button mat-menu-item *ngIf="!error"
        (click)="confirmDelete()">
  <span translate="TRANS__DELETE_ITEM__DELETE"></span>
</button>
